export const EXCLUDED_LOCALES: string[] = process.env.GATSBY_EXCLUDED_LOCALES?.split(',') || [];

export const languages = [
  {
    isoCode: 'en',
    isoName: 'English',
    locale: 'en-us',
    name: 'English (United States)',
    nativeName: 'English (United States)',
  },
  {
    isoCode: 'fr',
    isoName: 'French',
    locale: 'fr-fr',
    name: 'French (France)',
    nativeName: 'Français (France)',
  },
];

export const sites = languages.map(({ locale, ...rest }) => ({
  ...rest,
  hreflang: locale,
  id: locale,
  includeInHfrelangTags: !EXCLUDED_LOCALES.includes(locale),
  locale,
  path: `/${locale}`,
})).filter(({ id }) => !EXCLUDED_LOCALES.includes(id));

export const allLocales = sites.map(({ locale }) => locale);

export const locales = allLocales.filter((locale) => !EXCLUDED_LOCALES.includes(locale));
